import { render, staticRenderFns } from "./attr_hotpicker.vue?vue&type=template&id=37bd927c"
import script from "./attr_hotpicker.vue?vue&type=script&lang=js"
export * from "./attr_hotpicker.vue?vue&type=script&lang=js"
import style0 from "./attr_hotpicker.vue?vue&type=style&index=0&id=37bd927c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports